import { TCheckedType } from 'pages/calculation/types/index.type';
import { TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';
import { getIsCheckedProducts } from './get-is-checked-products.helper';

export const getTotalCostComplimentaryProducts = ({
  complimentaryProductInfo,
  checkedProducts,
}: {
  complimentaryProductInfo: TComplimentaryProductInfo[];
  checkedProducts: [] | TCheckedType;
}) =>
  complimentaryProductInfo.reduce((total, product) => {
    const isProductChecked = getIsCheckedProducts({ checkedProducts, productId: product.productId });

    const salesPrice =
      isProductChecked && product?.salesPriceValueInConsumerUnitValue !== undefined
        ? product.salesPriceValueInConsumerUnitValue
        : 0;
    const quantity = product.total.requiredQuantity;
    return total + salesPrice * quantity;
  }, 0);
